import React, { useEffect, useState } from "react";
import { Crown, Check } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { PayButtons, isTrialEligible } from "@/components/sg/PayButtons";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const openUpgrade = (feature) => window.dispatchEvent(new CustomEvent("sg:upgrade", { detail: feature || "" }));

const PERKS = [
  "Change orders your client signs",
  "\u201cPay now\u201d button + payment instructions",
  "Your brand colour, no ScopeGuard branding",
  "Daily reminders until signed + late-fee note",
  "Alert when your client opens the link",
  "One-tap texts from your own phone",
  "Income export for taxes",
];

export function UpgradeDialog() {
  const { user } = useAuth();
  const [feature, setFeature] = useState(null);
  const [annual, setAnnual] = useState(true);
  useEffect(() => {
    const on = (e) => { setAnnual(true); setFeature(e.detail); };
    window.addEventListener("sg:upgrade", on);
    return () => window.removeEventListener("sg:upgrade", on);
  }, []);
  if (!user || user.role === "owner" || user.plan === "super_premium") return null;
  const trial = isTrialEligible(user);
  return (
    <Dialog open={feature !== null} onOpenChange={(o) => !o && setFeature(null)}>
      <DialogContent className="max-w-md w-[calc(100vw-2rem)]" data-testid="upgrade-dialog">
        <DialogHeader>
          <div className="h-10 w-10 rounded-full bg-amber-500/15 flex items-center justify-center mb-2"><Crown className="h-5 w-5 text-amber-600" /></div>
          <DialogTitle className="font-display text-xl">Unlock with Super Premium</DialogTitle>
          <DialogDescription data-testid="upgrade-dialog-feature">
            {feature ? <><span className="font-semibold text-foreground">{feature}</span> is a Super Premium feature. </> : null}
            {trial ? "Try it free for 7 days — $0 today." : "Get every tool to get signed faster and paid sooner."}
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 text-sm">
          {PERKS.map((p) => <li key={p} className="flex items-start gap-2"><Check className="h-4 w-4 text-emerald-600 dark:text-emerald-400 mt-0.5 flex-shrink-0" />{p}</li>)}
        </ul>
        <div className="grid grid-cols-2 gap-2 mt-2">
          {[[false, "$17.99", "per month"], [true, "$183.48", "per year \u00b7 $15.29/mo"]].map(([a, price, sub]) => (
            <button key={String(a)} onClick={() => setAnnual(a)} data-testid={`upgrade-${a ? "yearly" : "monthly"}-option`}
              className={`rounded-lg border p-3 text-left transition-colors ${annual === a ? "border-indigo-500 bg-indigo-600/10" : "border-border hover:border-indigo-500/50"}`}>
              <div className="font-display font-bold tabular-nums">{price}</div>
              <div className="text-[11px] text-muted-foreground opacity-80">{sub}</div>
              {a && <div className="text-[10px] font-bold text-emerald-600 dark:text-emerald-400 mt-1">SAVE 15%</div>}
            </button>
          ))}
        </div>
        <PayButtons lookupKey={annual ? "super_premium_yearly" : "super_premium_monthly"} trial={trial} testPrefix="upgrade" />
      </DialogContent>
    </Dialog>
  );
}
